export default function useAnimate() {
  if (typeof window !== "undefined") {
    return (
      window.requestAnimationFrame ||
      window["webkitRequestAnimationFrame"] ||
      window["mozRequestAnimationFrame"]
    );
  } else {
    return (callback: Function) => {
      return setTimeout(callback, 1000 / 60);
    };
  }
}
